// Display-only formatting helpers (UK). Financial totals always come from the server.

export function formatMoney(value) {
  if (value === null || value === undefined || value === "") return "£0.00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "£0.00";
  return "£" + num.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function formatRate(value) {
  if (value === null || value === undefined || value === "") return "£0.00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "£0.00";
  // show up to 4 dp, min 2
  const str = num.toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
  const dp = (str.split(".")[1] || "").length;
  return "£" + num.toLocaleString("en-GB", { minimumFractionDigits: Math.max(2, dp), maximumFractionDigits: 4 });
}

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];

export function ordinal(n) {
  if (n % 100 >= 11 && n % 100 <= 13) return n + "th";
  return n + ({ 1: "st", 2: "nd", 3: "rd" }[n % 10] || "th");
}

export function formatUK(value) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d)) return "";
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getUTCFullYear()}`;
}

export function formatWritten(value) {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d)) return "";
  return `${ordinal(d.getUTCDate())} ${MONTHS[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

export function monthLabel(key) {
  if (!key) return "";
  const [y, m] = key.split("-");
  return `${MONTHS[parseInt(m, 10) - 1]} ${y}`;
}

export function toISODate(dateObj) {
  if (!dateObj) return null;
  const y = dateObj.getFullYear();
  const m = String(dateObj.getMonth() + 1).padStart(2, "0");
  const d = String(dateObj.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
